/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_SubtitleInputs */

const tr_iade_iptal_subtitle = /** @type {(inputs: Iade_Iptal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel SaaS aboneliğinin iptal edilmesi, feshedilmesi, 3 gün kuralına göre iade, veri ihracı ve hesap kapatma süreçleri. 6502 sayılı Kanun ve Abonelik Sözleşmeleri Yönetmeliği (RG 24.01.2015, sayı 29246) uyarınca.`)
};

const en_iade_iptal_subtitle = /** @type {(inputs: Iade_Iptal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procedures for cancelling and terminating the ShopPanel SaaS subscription, refunds under the 3-day rule, data export and account closure. Pursuant to 6502 sayılı Kanun and Abonelik Sözleşmeleri Yönetmeliği (RG 24.01.2015, sayı 29246).`)
};

const de_iade_iptal_subtitle = /** @type {(inputs: Iade_Iptal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abläufe für Kündigung, Beendigung, Erstattung nach der 3-Tage-Regel, Datenexport und Kontoschließung des ShopPanel SaaS Abonnements. Gemäß 6502 sayılı Kanun und Abonelik Sözleşmeleri Yönetmeliği (RG 24.01.2015, sayı 29246).`)
};

const ru_iade_iptal_subtitle = /** @type {(inputs: Iade_Iptal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Порядок отмены и расторжения подписки ShopPanel SaaS, возврата средств по правилу 3 дней, экспорта данных и закрытия учётной записи. В соответствии с 6502 sayılı Kanun и Abonelik Sözleşmeleri Yönetmeliği (RG 24.01.2015, sayı 29246).`)
};

/**
* | output |
* | --- |
* | "Procedures for cancelling and terminating the ShopPanel SaaS subscription, refunds under the 3-day rule, data export and account closure. Pursuant to 6502 sa..." |
*
* @param {Iade_Iptal_SubtitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_subtitle = /** @type {((inputs?: Iade_Iptal_SubtitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_SubtitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_subtitle(inputs)
	if (locale === "de") return de_iade_iptal_subtitle(inputs)
	if (locale === "ru") return ru_iade_iptal_subtitle(inputs)
	return tr_iade_iptal_subtitle(inputs)
});